import { fabric } from 'fabric';
import { CanvasDataTypes } from './canvas-data-types';

/**
 * Brings editable area border elements (EditableArea and StrokedMargin) to the front
 * of the canvas so the dashed zone boundary renders above photos.
 *
 * These elements have `evented: false` so they do not intercept mouse events,
 * allowing users to still select and interact with images beneath them.
 *
 * @param canvas - The fabric canvas instance
 */
export const bringEditableAreaBordersToFront = (canvas: fabric.Canvas | null | undefined): void => {
  if (!canvas) return;
  canvas.getObjects().forEach((obj) => {
    if (obj.data?.type === CanvasDataTypes.EditableArea || obj.data?.type === CanvasDataTypes.StrokedMargin) {
      obj.bringToFront();
    }
  });
};
